import styled from 'styled-components';
import { BASE_FIELD_STYLES } from './../styles';

export const FormFieldSC = styled.div`
  ${BASE_FIELD_STYLES}
`;
